import { render, staticRenderFns } from "./demo_edit.vue?vue&type=template&id=e22520ee"
import script from "./demo_edit.vue?vue&type=script&lang=js"
export * from "./demo_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports